import React from "react";
import { useLang } from "../../contexts/LanguageContext";
import Reveal from "../Reveal";
import { FileText, FileSpreadsheet, Presentation } from "lucide-react";

const ICONS = [Presentation, FileText, FileSpreadsheet];

export default function Docs() {
  const { t } = useLang();
  const c = t.docs;
  const scrollContact = (idx) => {
    const el = document.getElementById("contacto");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    // small hint via custom event so contact form pre-fills the type
    window.dispatchEvent(new CustomEvent("agro:contact-prefill", { detail: { type: "docs", index: idx } }));
  };

  return (
    <section id="documentacion" data-testid="docs-section" className="py-24 sm:py-32 border-t border-border">
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8">
        <div className="grid grid-cols-12 gap-y-10 gap-x-6 mb-16">
          <Reveal className="col-span-12 lg:col-span-3 flex items-start gap-4">
            <span className="block h-px w-12 bg-terracotta mt-3" aria-hidden />
            <span className="eyebrow">{c.eyebrow}</span>
          </Reveal>
          <Reveal as="h2" className="col-span-12 lg:col-span-9 h-section text-olive">
            {c.title}
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-border">
          {c.items.map((it, i) => {
            const Icon = ICONS[i] || FileText;
            return (
              <Reveal
                key={i}
                delay={i * 70}
                data-testid={`docs-card-${i}`}
                className="bg-ivory p-8 sm:p-10 flex flex-col gap-6"
              >
                <div className="flex items-center justify-between">
                  <Icon size={28} className="text-terracotta" />
                  <span className="font-mono text-[10px] tracking-[0.35em] uppercase text-olive-soft">.{it.tag.toLowerCase()}</span>
                </div>
                <div className="font-mono text-[10px] tracking-[0.35em] uppercase text-terracotta">{it.tag}</div>
                <h3 className="font-display text-2xl sm:text-3xl text-olive leading-tight">{it.title}</h3>
                <p className="text-olive-soft leading-relaxed flex-1">{it.body}</p>
                <button
                  onClick={() => scrollContact(i)}
                  data-testid={`docs-cta-${i}`}
                  className="self-start mt-2 font-mono text-[11px] tracking-[0.28em] uppercase border border-olive/40 text-olive px-5 py-3 hover:bg-olive hover:text-ivory transition"
                >
                  {it.cta} →
                </button>
              </Reveal>
            );
          })}
        </div>

        <Reveal>
          <p className="mt-8 font-mono text-[10px] tracking-[0.3em] uppercase text-olive-soft">{c.footnote}</p>
        </Reveal>
      </div>
    </section>
  );
}
